import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useDownline = (id) => useQuery({ queryKey: [`downline`, id], queryFn: async () => {
    if(!id) return {}
    const callback = await API.get(`/downlines/${id}`)
    return callback?.data
}})

export default useDownline